import useQuoteTemplateBuilder from './hooks/useQuoteTemplateBuilder'

import CampaignQuoteTemplate from './components/CampaignQuoteTemplate'
import QuoteBuilderContextProvider from '../QuoteBuilderContextProvider'

interface QuoteBuilderProps {
  quoteTemplateBuilderPayload: ReturnType<typeof useQuoteTemplateBuilder>,
}

const QuoteTemplateBuilder = (props: QuoteBuilderProps) => {
  const { quoteTemplateBuilderPayload } = props

  return (
    // @ts-expect-error TS2741
    <QuoteBuilderContextProvider value={quoteTemplateBuilderPayload}>
      <CampaignQuoteTemplate quoteTemplateBuilderPayload={quoteTemplateBuilderPayload} />
    </QuoteBuilderContextProvider>
  )
}

export default QuoteTemplateBuilder
